<template>
    <div>
        <section>
            <div class="row portfolio-container">
                <div class="col-md-12 col-lg-5">
                    <div class="logo">
                        <img src="/images/ready/logo.svg" alt="">
                        <div class="main-heading">ready</div>
                    </div>
                    <h1 class="super-heading">
                        Navigating Success Together Efficiently
                    </h1>
                    <div class="main-flex">
                        <div class="flex-data"
                        v-for="(data, index) in mainData" :key="index">
                            <h4>{{data.title  }}</h4>
                            <p>{{ data.description }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-2"></div>
                <div class="col-md-12 col-lg-5">
                    <div class="main-img mt">
                        <img src="/images/ready/main-img.png" alt="">
                    </div>
                </div>
            </div>
        </section>
        <div class="row portfolio-container">
            <h2 class="sub-heading">
                project description
            </h2>
            <p class="paragraph">
                Working parents do not have enough time to look after their 
                kid’s day care products while they are working. 
                They remain worried about their children’s well being and frustrate 
                about going to store and waiting in the queue. It bothers them so much.
            </p>
        </div>
        <div class="row portfolio-container">
                <h2 class="sub-heading">
                    home dashboard
                </h2>
                <div class="col-md-12 col-lg-12">
                    <div class="main-img">
                        <img src="/images/ready/home.png" alt="">
                    </div>
                </div>
        </div>
        <div class="row portfolio-container">
            <div class="grid">
                <div class="grid-flex" v-for="(item, index) in data" :key="index">
                        <h2 class="sub-heading">
                            {{ item.title }}
                        </h2>
                        <div class="main-img">
                            <img :src="item.url" alt="">
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                mainData: [
                    {
                        title: 'Platform',
                        description: 'Web App'
                    },
                    {
                        title: 'Deliverables',
                        description: 'Development'
                    },
                ],
                data: [
                    {
                        title: 'all templates',
                        url: '/images/ready/template.png'
                    },
                    {
                        title: 'initiatives',
                        url: '/images/ready/initiative.png'
                    },
                    {
                        title: 'playbooks',
                        url: '/images/ready/playbook.png'
                    },
                    {
                        title: 'user stories',
                        url: '/images/ready/user-stories.png'
                    },
                    {
                        title: 'favourite template',
                        url: '/images/ready/fav.png'
                    },
                    {
                        title: 'global fake entity',
                        url: '/images/ready/fake.png'
                    },
                    {
                        title: 'team sprint',
                        url: '/images/ready/team.png'
                    },
                    {
                        title: 'right restriction',
                        url: '/images/ready/restriction.png'
                    },
                ]
            }
        }
        
    }
</script>

<style scoped>
    section{
        background: linear-gradient(180deg, #000000 -303.13%, rgba(0, 189, 160, 0.43) -32.5%, #020103 98.38%);
        margin-top: 3em;
    }
    .portfolio-container{
        margin-bottom: -8em !important;
    }
    .logo{
        display: flex;
        width: 15%;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1em;
    }
    .logo .main-heading{
        font-size: 2em;
        text-transform: capitalize;
        color: #fff;
        font-weight: 800;
    }
    .super-heading{
        font-size: 3em;
        font-weight: 900;
        margin-bottom: 1em;
    }
    .main-flex{
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .main-flex .flex-data{
        display: flex;
        flex-direction: column;
        margin-bottom: 2em;
    }
    .flex-data h4{
        font-size: 1.5em;
        font-weight: 500;
        line-height: 1em;
    }
    .flex-data p{
        font-size: 1em;
        font-weight: 500;
        color: #fff;
    }
    .main-img {
    width: 100%;
}
.main-img img {
    width: 100%;
    height: auto;
}
.sub-heading {
    font-size: 2.5em;
    font-weight: 600;
    text-align: center;
    text-transform: capitalize;
    margin: 1.5em 0 1em 0;
}

.paragraph {
    font-size: 1.25em;
    font-weight: 400;
    letter-spacing: 0.3px;
    text-align: center;
    color: #fff;
    padding: 0 5em;
}
.grid{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2em;
    padding: 0 1em;
}
@media (min-width: 1440px) {
    .logo .main-heading{
        font-size: 3em;
        text-transform: capitalize;
        color: #fff;
        font-weight: 800;
    }
    .super-heading{
        font-size: 5em;
        font-weight: 900;
        margin-bottom: 1.5em;
    }
    .main-flex{
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .main-flex .flex-data{
        display: flex;
        flex-direction: column;
        margin-bottom: 2em;
    }
    .flex-data h4{
        font-size: 2.5em;
        font-weight: 500;
        line-height: 1em;
    }
    .flex-data p{
        font-size: 1.5em;
        font-weight: 500;
        color: #fff;
    }
    .paragraph {
        font-size: 1.5em;
        padding: 0 15em;
    }

    .sub-heading {
        font-size: 3.5em;
        font-weight: 800;
    }    
}
@media (max-width:768px) {
    .portfolio-container{
        margin-bottom: -4em !important;
    }

    .paragraph {
        font-size: .75em;
        text-align: center;
        line-height: 1.5em;
        padding: 0 2em;
    }

    .sub-heading {
        font-size: 2em;
    }
    .super-heading {
        font-size: 3em;
        margin-bottom: 1em;
    }
    .main-flex{
        margin-bottom: 5em;
    }

    .main-flex h4 {
        font-size: 1.5em;
        font-weight: 500;
        text-transform: capitalize;
    }

    .main-flex span {
        color: #fff !important;
        font-size: 1em;
        font-weight: 400;

    }
    .data-flex img{
        width: 5em;
        height: auto;
    }
.grid {
    grid-template-columns: 1fr;
    margin-bottom: 2em;
}
}
@media (max-width:480px) {
    .portfolio-container{
        margin-bottom: 0 !important;
    }

.logo {
    width: 40%;
    margin-top: 2em;
}
    .paragraph {
        font-size: 1em;
        line-height: 1.5em;
        text-align: justify;
    }

    .sub-heading {
        font-size: 1.25em;
        font-weight: 900;
    }
    .main-flex .main-heading{
        line-height: 1em;
        font-size: 1.5em;
    }

    .super-heading {
        font-size: 2.5em;
        line-height: 1.1em;
        letter-spacing: normal;
        font-weight: 900;
        margin-bottom: .5em;
    }

    .main-flex h4 {
        font-size: 1.5em;
        font-weight: 600;
        line-height: 0.75em;
        margin-bottom: 0;
        text-transform: capitalize;
    }
    .main-flex{
        margin-bottom: 2em;
    }
    .main-flex p {
        color: #fff !important;
        font-size: 1em;
        font-weight: 400;

    }
    .data-flex img{
        width: 3em;
        height: auto;
        margin-bottom: 1em;
    }
    .data-flex span{
        font-size: .5em;
    }
    .skeleton-grid{
        display: none;
    }
    .row .custom-grid {
        grid-template-columns: 1fr;
    }
    .row .custom-grid .order{
        order: 1;
    }
}
</style>